'use client'

import * as React from 'react'
import { useInView, useReducedMotion } from 'framer-motion'

// One-pass emphasis on the Idukki column of the comparison matrix.
// When the table scrolls into view the wrapper gains a `data-lit`
// attribute; the Idukki cells (styled with `group-data-[lit]:…` classes
// in the server-rendered table) settle into a ~5% lime wash. Fires once,
// never re-triggers, and under reduced motion the wash is simply the
// initial state — no transition plays.

export function CompareTableHighlight({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  const ref = React.useRef<HTMLDivElement>(null)
  const inView = useInView(ref, { once: true, margin: '0px 0px -10% 0px' })
  const reduce = useReducedMotion()
  const lit = reduce || inView

  return (
    <div ref={ref} className={`group ${className ?? ''}`} data-lit={lit ? '' : undefined}>
      {children}
    </div>
  )
}
